import React, { ChangeEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { nullToString } from 'src/pages/CompanyPage/ui//dataPointGenerator/fields/_helpers/valueHelpers';
import { StringInput } from 'src/shared/ui/_inputs/StringInput';
import { InfoTooltip } from 'src/shared/ui/_tooltips/InfoTooltip';
import s from './StringField.module.scss';

export const StringField: React.FC<GeneratedField> = (props) => {
	const { namePrefix, propertyName, internalName, measureUnits, validate } = props;

	// * Form
	const { setValue, control, trigger } = useFormContext();

	const name = `${namePrefix}${propertyName}.${internalName}`;

	const textFieldOnChangeHandler = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, fieldName: string) => {
		if (event.currentTarget.value.trim() === '') {
			setValue(fieldName, null);
		} else {
			setValue(fieldName, event.target.value);
		}
	};

	// * Render
	return (
		<Controller
			name={`${name}.value`}
			control={control}
			rules={{ validate: validate }}
			render={({ field, fieldState }) => (
				<div>
					<div className={s.fieldWrapper}>
						<StringInput
							{...field}
							className={s.textField}
							value={nullToString(field.value)}
							onChange={(event) => textFieldOnChangeHandler(event, field.name)}
							onBlur={(event) => (field.value !== null ? setValue(field.name, event.currentTarget.value.trim(), { shouldValidate: true }) : trigger())}
							size="middle"
							addonAfter={<InfoTooltip info={nullToString(field.value)} />}
							suffix={measureUnits}
							error={fieldState.error?.message}
						/>
						{measureUnits && <span className={s.additionalTextRight}>{measureUnits}</span>}
					</div>
				</div>
			)}
		/>
	);
};
